export default {
	SET_LEAD(state, payload) {
		state.lead = payload;
	}
};



// WEBPACK FOOTER //
// ./sources/app/simulator/simulator/mutations.js